import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class KeepAliveApiService {
  private readonly http = inject(HttpClient);

  public updateKeepAlive(): Observable<never> {
    return this.http.post<never>(
      environment.keepAliveUrl,
      {},
      {
        withCredentials: true
      }
    );
  }
}
